import { Form, Link, useRouteLoaderData, Await, useNavigation } from 'react-router';
import { XMarkIcon, CheckIcon } from '@heroicons/react/24/outline';
import { Suspense } from 'react';

const TitleEditForm = () => {
  const { results } = useRouteLoaderData('node');
  const { state } = useNavigation();
  const isSubmitting = state === 'submitting' || state === 'loading';

  return (
    <div className="shadow-md p-2 m-2 rounded-sm">
      <Suspense fallback={<></>}>
        <Await resolve={results}>
          {resolvedResults => {
            const { node } = resolvedResults || {};
            return (
              <Form method="put">
                <div className="flex flex-col gap-1">
                  <div>
                    <input
                      name="name"
                      defaultValue={node?.label}
                      type="text"
                      className="input-bordered input-sm w-full rounded-none truncate"
                    />
                  </div>
                  <div className="flex gap-2 items-center justify-end">
                    {isSubmitting && <div className="text-xs text-gray-500">Saving...</div>}
                    <div className="flex gap-2">
                      <Link to={'..'} replace className="btn btn-xs px-1 btn-ghost border-zinc-400">
                        <XMarkIcon className="h-5 w-5 text-zinc-400" />
                      </Link>
                      <button
                        type="submit"
                        disabled={isSubmitting}
                        className={`btn btn-xs px-1 text-white bg-purple-500 border-purple-500 ${isSubmitting ? 'opacity-50 cursor-not-allowed' : ''}`}
                      >
                        <CheckIcon className="h-5 w-5" />
                      </button>
                    </div>
                  </div>
                </div>
              </Form>
            );
          }}
        </Await>
      </Suspense>
    </div>
  );
};

export default TitleEditForm;
